@if (mode==="basic") {
  <icc-select-box [imageUrl]="'/files/awningvalance/' + selectedFrill.img" [title]="selectedFrill.name || 'Brak Falbany'" [buttonText]="'Zmień'" (select)="onFrillChange()">
  </icc-select-box>
}
@if (mode==="list") {
  <icc-list itemImgHeight="medium" itemTemplate="itemImgTitle" (select)="selectFrill($event)" [items]='frills'>
  </icc-list>
}
